export const minLengthRule = (minLength: number) => ({
	name: 'min-length',
	validate: (value: string) => value.trim().length >= minLength,
});
